// extracted by mini-css-extract-plugin
export default {"root":"PlasmicSignOutButton_root__0orl2","text":"PlasmicSignOutButton_text__wTIVM"};